<template>
  <div class="row dnone">
    <div class="col-12">
        <h3 class="text-center g" style="border: dashed #ddd 2px; background: #fefefe">
            نموذج طلب للعمل الموسمي بشركة عالم البشائر .
        </h3>
        <h5 class="text-s g">
             اختر الخدمة المطلوبة:
        </h5>
    </div>
    <div class="col-6 col-lg-3">
        <div class="card border shadow item" @click="$router.push('/create/register')">
            <div class="card-header">
                <img :src="require('@/assets/images/register.png')" class="c">
            </div>
            <div class="card-body">
                <h5>
                    التسجيل
                </h5>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-3">
        <div class="card border shadow item" @click="$router.push('/create2/add-file')">
            <div class="card-header">
                <img :src="require('@/assets/images/file.png')" class="c">
            </div>
            <div class="card-body">
                <h5>
                    إضافة العقد
                </h5>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    created(){
        var g = this;
    },
}
</script>

<style>
.item:hover{
    border: solid 1px gold !important;
}
.item img{
    width: 64px
}
.item *, .item{
    text-align: center;
}
</style>